import { useTranslation } from "@/hooks/useTranslation";
import { getTimeSinceText } from "@/utils/timestamp";
import { Chip, Typography } from "@st-marketplace/ui";
import { useEffect, useState } from "react";

const CooldownCell: React.FC<{ until?: string | null }> = ({ until }) => {
	const { t, lang } = useTranslation();
	const [now, setNow] = useState(Date.now);

	// the list doesn't poll, so tick the countdown ourselves
	useEffect(() => {
		if (!until) return;
		const id = setInterval(() => setNow(Date.now()), 60_000);
		return () => clearInterval(id);
	}, [until]);

	if (!until || new Date(until).getTime() <= now) {
		return <Typography variant="body-sm">-</Typography>;
	}

	return (
		<Chip variant="warning" size="sm">
			{t("sender.cooldownUntil", {
				time: getTimeSinceText(until, t, lang),
			})}
		</Chip>
	);
};

export default CooldownCell;
